import { Link } from '@phosphor-icons/react';

export default Link;
